import { fadeOut } from './helpers';
export const fadeOutPreloader = () => {
    const preloader = document.querySelector('.site-preloader');
    if (preloader)
        fadeOut(preloader);
};
export const initScrollHeader = () => {
    const header = document.querySelector('.js--site-header');
    if (!header)
        return;
    const update = () => {
        header.classList.toggle('scroll-header', Math.floor(window.scrollY) > 100);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
};
